import { LinearProgress, Money, Typography } from '@razz-team/ui-web';

import { Stack } from '@razz-team/ui-web';
import { ApiCard } from '../../../openapi';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function CardSpendingLimitView({ card }: { card: ApiCard }) {
  const { t } = useTranslation();
  const spentPercent = useMemo(() => {
    const limit = card?.spendingLimitPolicy.limit?.amount;
    const spent = card?.spendingLimitPolicy.spentAmount?.amount;
    return limit && spent ? (spent / limit) * 100 : 0;
  }, [card?.spendingLimitPolicy.limit?.amount, card?.spendingLimitPolicy.spentAmount?.amount]);

  return (
    <Stack spacing={2}>
      <LinearProgress
        value={spentPercent}
        valueBuffer={100}
        variant="buffer"
        color="info"
        sx={{ height: '8px', borderRadius: '99px' }}
      />
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="subtitle2" color="GrayText">
          {t('Spending limit')}
        </Typography>
        <Stack direction="row">
          <Money variant="subtitle2" value={card?.spendingLimitPolicy?.spentAmount} />
          {' / '}
          <Money variant="subtitle2" color="GrayText" value={card?.spendingLimitPolicy?.limit} />
        </Stack>
      </Stack>
    </Stack>
  );
}
